import productDetailStore from './productDetail/productDetail';

export default {
    productDetailStore
};
